import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_VARIANT_TODDLE_PLAY,
} from "Constants/stringConstants";
export const WORKRAMP_ACADEMY = "WORKRAMP_ACADEMY";
export const AUTH_AND_EVAL = "auth_and_eval";
export const TODDLE_LIBRARY = "TODDLE_LIBRARY";
export const TODDLE_AI = "TODDLE_AI";
export const AI_TUTOR = "AI_TUTOR";
export const AI_TUTOR_MODALITIES = "AI_TUTOR_MODALITIES";
export const TODDLE_ANALYTICS = "TODDLE_ANALYTICS";
export const ENGAGEMENT_ANALYTICS = "ENGAGEMENT";
export const PERFORMANCE_ANALYTICS = "PERFORMANCE";
export const BEHAVIOUR_ANALYTICS = "BEHAVIOUR";
export const MODULE_USAGE_ANALYTICS = "MODULE_USAGE";
export const ATTENDANCE_ANALYTICS = "ATTENDANCE";
export const WORKSHEET = "WORKSHEET";
export const WORKSHEET_AI = "WORKSHEET_AI";
export const AI_GRADING = "AI_GRADING";
export const UNIT_PLANNING_AI = "UNIT_PLANNING_AI";
export const IMPORT_UNIT_FROM_OTHER_CURRICULUM = "IMPORT_OTHER_CURRICULUM_UNIT";
export const WORKSHEET_BASIC = "WORKSHEET_BASIC";
export const WORKRAMP_ACADEMY_TYPE_CONFIG_ID = "71887912504923283";
export const MESSAGING = "MESSAGING";
export const ADD_ON_MANAGER = "ADD_ON_MANAGER";
export const CURRICULUM_PROGRAM = "CURRICULUM_PROGRAM";
export const GLOBAL = "GLOBAL";
export const ENABLE = "ENABLE";
export const DISABLE = "DISABLE";
export const USER = "USER";
export const ACADEMIC_YEAR_TRANSITION = "ACADEMIC_YEAR_TRANSITION";
export const ORGANIZATION = "ORGANIZATION";
export const ACTIVITY_TRACKER = "ACTIVITY_TRACKER";
export const BEHAVIOUR_MANAGEMENT = "BEHAVIOUR_MODULE";
export const STUDENT_PRONOUNS = "PRONOUNS";
export const IN_APP_TRANSLATION = "IN_APP_TRANSLATION";
export const DP_1_AND_DP_2_STUDENTS = "DP_1_AND_DP_2_STUDENTS";
export const IBIS_REGISTRATION_REVAMP = "IBIS_REGISTRATION_REVAMP";
export const ADD_ADMIN_TO_ALL_CLASSES = "ADD_ADMIN_TO_ALL_CLASSES";
export const CROSS_CURRICULUM_STUDENTS = "CROSS_CURRICULUM_STUDENTS";
export const ROLES_AND_PERMISSIONS = "ROLES_AND_PERMISSIONS";
export const ATTENDANCE_SETTINGS_V2_CONFIG_ID = "136957547767666416";
export const BLUEPRINT_SYNC = "BLUEPRINT_SYNC";
export const ROSTER_SYNC = "ROSTER_SYNC";
export const TIMETABLE_SYNC = "TIMETABLE_SYNC";
export const ATTENDANCE_SYNC = "ATTENDANCE_SYNC";

export const ROSTER_SYNC_SUB_TYPES = {
  BASE_SYNC: "BASE_SYNC",
  LR_ARCH_ENABLE: "LR_ARCH_ENABLE",
  SYNC_SETUP_BUTTON: "SYNC_SETUP_BUTTON",
  BULK_MAPPING_BUTTON: "BULK_MAPPING_BUTTON",
};

export const TIMETABLE_SYNC_SUB_TYPES = {
  BASE_SYNC: "BASE_SYNC",
  LR_ARCH_ENABLE: "LR_ARCH_ENABLE",
};

export const ATTENDANCE_SYNC_SUB_TYPES = {
  BASE_SYNC: "BASE_SYNC",
  LR_ARCH_ENABLE: "LR_ARCH_ENABLE",
};

export const TODDLE_AI_MODULES = [
  {
    id: "LESSON_PLANNING_AI",
    label: "ai:lesson_planning_ai",
  },
  {
    id: "ANNOUNCEMENT_AI",
    label: "ai:announcement_ai",
  },
  {
    id: "PROGRESS_REPORT_AI",
    label: "ai:progress_report_ai",
  },
  {
    id: "PORTFOLIO_AI",
    label: "ai:portfolio_ai",
  },
  {
    id: "UNIT_PLANNING_AI",
    label: "unitPlan:curriculum_design_assistant",
  },
];

export const MESSAGING_MODULES = {
  PAID_MODULE: "PAID_MODULE",
  CHATS_AND_CHANNELS: "CHATS_AND_CHANNELS",
  OVERVIEW: "OVERVIEW",
  CHAT_CHANNELS_AI_ADD_ONS: "CHAT_CHANNELS_AI_ADD_ONS",
  OVERVIEW_WITH_AI: "OVERVIEW_WITH_AI",
  SETTINGS: "SETTINGS",
  ANALYTICS: "ANALYTICS",
};

export const MESSAGING_MODULES_DETAILS = {
  [MESSAGING_MODULES.PAID_MODULE]: {
    label: "common:paid",
    id: MESSAGING_MODULES.PAID_MODULE,
    isGlobalToggleAvailable: true,
    globalToggleLabel: "common:school_wide",
  },
  [MESSAGING_MODULES.CHATS_AND_CHANNELS]: {
    label: "common:messaging_module",
    id: MESSAGING_MODULES.CHATS_AND_CHANNELS,
    isGlobalToggleAvailable: true,
    globalToggleLabel: "common:school_wide",
  },
  [MESSAGING_MODULES.OVERVIEW]: {
    label: "common:overview",
    id: MESSAGING_MODULES.OVERVIEW,
    isGlobalToggleAvailable: true,
    globalToggleLabel: "common:all_admins",
    isCustomSelectorAvailable: true,
    customSelectorLabel: "common:select_admins",
  },
  [MESSAGING_MODULES.CHAT_CHANNELS_AI_ADD_ONS]: {
    label: "common:chats_and_channels_with_ai",
    id: MESSAGING_MODULES.CHAT_CHANNELS_AI_ADD_ONS,
    isGlobalToggleAvailable: true,
    globalToggleLabel: "common:all_staff",
  },
  [MESSAGING_MODULES.OVERVIEW_WITH_AI]: {
    label: "common:overview_with_ai",
    id: MESSAGING_MODULES.OVERVIEW_WITH_AI,
    isGlobalToggleAvailable: true,
    globalToggleLabel: "common:all_admins",
    isCustomSelectorAvailable: true,
    customSelectorLabel: "common:select_admins",
  },
  [MESSAGING_MODULES.SETTINGS]: {
    label: "common:settings",
    id: MESSAGING_MODULES.SETTINGS,
    isGlobalToggleAvailable: true,
    globalToggleLabel: "common:all_admins",
    isCustomSelectorAvailable: true,
    customSelectorLabel: "common:select_admins",
  },
  [MESSAGING_MODULES.ANALYTICS]: {
    label: "common:analytics",
    id: MESSAGING_MODULES.ANALYTICS,
    isGlobalToggleAvailable: true,
    globalToggleLabel: "common:all_admins",
    isCustomSelectorAvailable: true,
    customSelectorLabel: "common:select_admins",
  },
};

export const TODDLE_ANALYTICS_MODULES = [
  {
    id: ENGAGEMENT_ANALYTICS,
    label: "toddleAnalytics:engagement_insights",
    lastSyncQueryVariablesKey: "engagementLastSyncQueryVariables",
  },
  {
    id: MODULE_USAGE_ANALYTICS,
    label: "toddleAnalytics:usage_insights",
    perm: "FeatureFlag:ShowModuleUsageInsightsInAddon",
    lastSyncQueryVariablesKey: "usageLastSyncQueryVariables",
  },
  {
    id: PERFORMANCE_ANALYTICS,
    label: "toddleAnalytics:performance_insights",
    disabledCurriculums: [CURRICULUM_TYPE_PYP],
    disabledVariants: [CURRICULUM_VARIANT_TODDLE_PLAY],
    lastSyncQueryVariablesKey: "performanceLastSyncQueryVariables",
  },
  {
    id: BEHAVIOUR_ANALYTICS,
    label: "toddleAnalytics:behaviour_insights",
    perm: "FeatureFlag:ShowBehaviourInsightsInAddon",
    lastSyncQueryVariablesKey: "behaviourLastSyncQueryVariables",
  },
  {
    id: ATTENDANCE_ANALYTICS,
    label: "toddleAnalytics:attendance_insights",
    perm: "FeatureFlag:ShowAttendanceInsightsInAddon",
    modulePermConfigId: ATTENDANCE_SETTINGS_V2_CONFIG_ID,
    lastSyncQueryVariablesKey: "attendanceLastSyncQueryVariables",
  },
];
